import 'css-chunksrc/client/scenes/optimizedGantt/calendar/dailyMonths/month/styles.scss';export default {
  "month": "_month_bkbi3_1",
  "year": "_year_bkbi3_17"
};